const iconsCollections = [
  [ /* '⓿', */ '０' ],
  [ /* '❶', */ /* '①', '⑴', '⒈', */ '１' ],
  [ /* '❷', */ /* '②', '⑵', '⒉', */ '２' ],
  [ /* '❸', */ /* '③', '⑶', '⒊', */ '３' ],
  [ /* '❹', */ /* '④', '⑷', '⒋', */ '４' ],
  [ /* '❺', */ /* '⑤', '⑸', '⒌', */ '５' ],
  [ /* '❻', */ /* '⑥', '⑹', '⒍', */ '６' ],
  [ /* '❼', */ /* '⑦', '⑺', '⒎', */ '７' ],
  [ /* '❽', */ /* '⑧', '⑻', '⒏', */ '８' ],
  [ /* '❾', */ /* '⑨', '⑼', '⒐', */ '９' ]
  // [ /* '❿', */ /* '⑩', '⑽', '⒑'  */],
  // [ /* '⓫', */ /* '⑪', '⑾', '⒒'  */],
  // [ /* '⓬', */ /* '⑫', '⑿', '⒓'  */],
  // [ /* '⓭', */ /* '⑬', '⒀', '⒔'  */],
  // [ /* '⓮', */ /* '⑭', '⒁', '⒕'  */],
  // [ /* '⓯', */ /* '⑮', '⒂', '⒖'  */],
  // [ /* '⓰', */ /* '⑯', '⒃', '⒗'  */],
  // [ /* '⓱', */ /* '⑰', '⒄', '⒘'  */],
  // [ /* '⓲', */ /* '⑱', '⒅', '⒙'  */],
  // [ /* '⓳', */ /* '⑲', '⒆', '⒚'  */],
  // [ /* '⓴', */ /* '⑳', '⒇', '⒛'  */]
]

const regExpOnlyDigits = new RegExp(/\d/, 'g')
const regExpPairOfNumber = new RegExp(/(20|1\d)/, 'y')

const getRandomNumber = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min

const getRandomChance = () => Math.random() < 0.5

const getRandomIconForNumber = number => {
  const collection = iconsCollections[number]

  return collection[getRandomNumber(0, collection.length - 1)]
}

exports.numbersToIcons = string => {
  let result = string

  if (iconsCollections.length === 21) {
    for (let index = 0; index < string.length; index++) {
      regExpPairOfNumber.lastIndex = index

      let isMatched = false
      result = result.replace(regExpPairOfNumber, value => {
        isMatched = true
        if (getRandomChance()) {
          return getRandomIconForNumber(value)
        }

        return value
      })

      if (!isMatched) {
        break
      }
    }
  }

  result = result.replace(regExpOnlyDigits, value => {
    return getRandomIconForNumber(value)
  })

  return result
}
